var map = {
  "./en.json": [
    "26242"
  ],
  "./de.json": [
    "7466",
    "8567"
  ],
  "./es-ES.json": [
    "84780",
    "4029"
  ],
  "./es.json": [
    "29089",
    "9210"
  ],
  "./fr-FR.json": [
    "63528",
    "4993"
  ],
  "./ja.json": [
    "5600",
    "7417"
  ],
  "./pt-BR.json": [
    "38116",
    "4149"
  ]
};
function __rspack_async_context(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(function() {
      var e = new Error("Cannot find module '" + req + "'");
      e.code = 'MODULE_NOT_FOUND';
      throw e;
    });
  }

  var ids = map[req], id = ids[0];
  return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
    return __webpack_require__.t(id, 3 | 16);
  });
}

__rspack_async_context.keys = function() { return Object.keys(map); };
__rspack_async_context.id = 94652;
module.exports = __rspack_async_context;
